module.exports = __webpack_public_path__ + "img/speech-bubble.41f98076.png";